import { Avatar, Box, Chip, Grid } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
import {
  Body,
  BodyOverlay,
  ButtonCont,
  FeaturesCont,
  FeaturesItem,
  GenesisNftItem,
  HelpText,
  HomeSection,
  HomeSubSection,
  HomeText,
  ParaText,
  SectionVideo,
  SectionVideoCont,
  TextCont,
  TitleText,
} from './NftPrometheus.styles';

const NftPrometheus = () => {
  const artworkVideo = require('assets/artwork.mp4');
  const logo = require('assets/logo_small.svg');


  return (
    <Body>
      <BodyOverlay></BodyOverlay>

      <HomeSection sx={{ pt: '10vh' }} container>
        <Grid item xs={12} md={12} lg={5.9}>
          <HomeSubSection style={{ position: 'relative' }}>
            <SectionVideoCont>
              <SectionVideo
                src={`${artworkVideo}`}
                muted
                autoPlay
                loop
                playsInline
              ></SectionVideo>
              <TextCont>
                <TitleText style={{ fontSize: '27px' }}>
                  Buku Prometheus NFT
                </TitleText>
                <ParaText style={{ fontSize: '17px' }}>
                  <span>Created by</span>
                  <Chip
                    avatar={
                      <Avatar
                        src={logo.default}
                        sx={{
                          width: '35px !important',
                          height: '35px !important',
                          background: '#2c2c2f',
                          '& img': {
                            width: '18px',
                            height: '21px',
                            objectFit: 'contain',
                          },
                        }}
                      />
                    }
                    label="@Buku"
                    variant="outlined"
                    sx={{
                      marginLeft: '10px',
                      color: '#fff',
                      fontWeight: 'bold',
                      backgroundColor: 'rgba(255, 255, 255, 0.18)',
                      border: 'none',
                      padding: '20px 5px',
                      borderRadius: '50px',
                    }}
                  />
                </ParaText>
                <ParaText style={{ fontSize: '17px' }}>
                  The Prometheus NFT is a first of its kind to be created by
                  Buku. This mystery NFT will award you with different unknown
                  rarity levels and different attributes.
                </ParaText>
              </TextCont>
            </SectionVideoCont>
            {/* <ParaText sx={{ fontSize: '15px', margin: '30px auto', display: 'flex', alignItems: 'center' }}>
                            RESERVE PRICE 
                            <div style={{
                                marginLeft: '40px',
                                fontSize: '22px',
                                display: 'flex',
                                alignItems: 'start'
                            }}>
                                0.11
                                <span style={{
                                    color: '#c1c1c1',
                                    fontSize: '18px',
                                    marginLeft: '5px',
                                    marginTop: '2px'
                                }}> ETH</span>
                            </div>
                        </ParaText> */}
          </HomeSubSection>
        </Grid>

        <Grid item xs={12} md={12} lg={6.1}>
          <HomeSubSection >
            <HomeText
              style={{
                textAlign: 'center',
                maxWidth: '800px',
              }}
            >
              <TitleText style={{ fontSize: '29px' }}>
                Prometheus NFT Utility
              </TitleText>
              <ParaText style={{ fontSize: '18px' }}>
                An early access ticket to the future of social media. An
                Ecosystem for content creators.
              </ParaText>

              <FeaturesCont>
                <GenesisNftItem
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: 'inherit',
                    padding: '0px',
                  }}
                >
                  <FeaturesItem
                    style={{
                      width: '46%',
                      marginRight: '3%',
                      position: 'relative',
                    }}
                  >
                    <h5>Lifetime granted advertisement points 🔥</h5>
                    <p>10 advertisement points a month to sponsor your posts</p>
                  </FeaturesItem>
                  <FeaturesItem style={{ width: '46%' }}>
                    <h5>Lock in your username 🔒</h5>
                    <p>
                      Be early in the game, claim your username! No more
                      yolo420x360noscope!
                    </p>
                  </FeaturesItem>
                </GenesisNftItem>

                <GenesisNftItem
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: 'inherit',
                    padding: '0px',
                  }}
                >
                  <FeaturesItem
                    style={{
                      width: '46%',
                      marginRight: '3%',
                      position: 'relative',
                    }}
                  >
                    <h5>Access to Pre-Alpha 💎</h5>
                    <p>
                      Be the first creators to help shape Buku from its
                      foundation!
                    </p>
                  </FeaturesItem>
                  <FeaturesItem
                    style={{
                      width: '46%',
                    }}
                  >
                    <h5>Featured artist spotlight 🌟</h5>
                    <p>
                      Featured Artist Spotlight one time a week during closed
                      beta for six hours.
                    </p>
                  </FeaturesItem>
                </GenesisNftItem>

                <GenesisNftItem>
                  <h5>First to access our Genesis NFT 👀 </h5>
                  <p>
                    • Genesis will grant our users access to exclusive events
                  </p>
                  <p>
                    {' '}
                    • Genesis will grant our users special voting power over
                    upcoming features And a lot more features to be announced!
                  </p>
                </GenesisNftItem>
              </FeaturesCont>

              <ButtonCont>
                <NormalButton
                  style={{
                    width: '100%',
                    padding: '14px 5px',
                    backgroundColor: 'rgb(221, 185, 48)',
                    minWidth: '280px',
                    fontSize: '15px',
                  }}
                >
                  Coming Soon
                </NormalButton>
                <NormalButton
                  onClick={() =>
                    window.open('https://discord.gg/pEqAAMtCbx', '_blank')
                  }
                  style={{
                    width: '100%',
                    padding: '14px 5px',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    minWidth: '280px',
                    fontSize: '15px',
                  }}
                >
                  Join Discord
                </NormalButton>
              </ButtonCont>

              <Box
                sx={{
                  padding: '0px 30px',
                  textAlign: 'start',
                }}
              >
                <HelpText>
                  Minting coming soon. Join Discord for more information!
                </HelpText>
              </Box>
            </HomeText>
          </HomeSubSection>
        </Grid>
      </HomeSection>
    </Body>
  );
};

export default NftPrometheus;
